// extracted by mini-css-extract-plugin
module.exports = {"prizeBadgeOverlay":"PrizeBadgeOverlay_prizeBadgeOverlay__3varq","badge":"PrizeBadgeOverlay_badge__1AczI","text":"PrizeBadgeOverlay_text__bdhyV"};